'use strict';

var fragt = fragt || {};
var novicell = novicell || {};

fragt.languageSelector = fragt.languageSelector || new function () {
    this.init = function () {
        var langSelBtns = document.querySelectorAll('.js-language-selector-button');
        var activeClass = 'language-selector__button--active';

        for (var i = 0; i < langSelBtns.length; i++) {
            var btn = langSelBtns[i];
            btn.addEventListener('click', function (e) {
                if (this.classList.contains(activeClass)) {
                    this.classList.remove(activeClass);
                } else {
                    this.classList.add(activeClass);
                }
            });
        }
    };
}();
